var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { staticStyle: { "overflow-y": "hidden" }, attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.verDetalle,
            expression: "!verDetalle"
          }
        ],
        attrs: { titulo: "Editar Ruta" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CabeceraModal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.verDetalle,
            expression: "verDetalle"
          }
        ],
        attrs: { titulo: "Ver Ruta" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": 400 },
          model: {
            value: _vm.confirm,
            callback: function($$v) {
              _vm.confirm = $$v
            },
            expression: "confirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { "font-size": "17px" },
                  attrs: { dark: "", color: "primary" }
                },
                [_vm._v("\n        Guardar Cambios\n      ")]
              ),
              _c("divider"),
              _c("v-card-text", [
                _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _vm._v(
                      "\n            Al guardar los cambios, las tarifas que se encuentren señaladas en\n            rojo serán eliminadas.\n          "
                    )
                  ]),
                  _c("br"),
                  _c("div", [_vm._v("¿Desea continuar?")])
                ])
              ]),
              _c("divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "white", small: "" },
                      on: {
                        click: function($event) {
                          _vm.confirm = false
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cancelar")
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#526da5", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.sendData()
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                absolute: "",
                color: "transparent",
                active: _vm.seleccionado
              },
              on: {
                "update:active": function($event) {
                  _vm.seleccionado = $event
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: true,
                      expression: "true"
                    }
                  ],
                  attrs: { title: "Categorias", color: "primary", flat: "" }
                },
                [
                  _c("span", [_vm._v("Categorías")]),
                  _c("v-icon", [_vm._v("directions_car")])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: true,
                      expression: "true"
                    }
                  ],
                  attrs: { title: "Rutas", color: "primary", flat: "" }
                },
                [
                  _c("span", [_vm._v("Rutas")]),
                  _c("v-icon", [_vm._v("route")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hoover",
                  modifiers: { hoover: true }
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.verDetalle,
                  expression: "!verDetalle"
                }
              ],
              staticClass: "ma-2",
              attrs: {
                title: "Agregar",
                color: "primary",
                fab: "",
                large: "",
                right: "",
                absolute: ""
              },
              on: {
                click: function($event) {
                  return _vm.showAdd()
                }
              }
            },
            [_c("v-icon", [_vm._v("add")])],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.seleccionado == 0,
              expression: "seleccionado == 0"
            }
          ],
          staticClass: "card",
          staticStyle: { width: "85%", "overflow-y": "auto" }
        },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.seleccionado == 1,
              expression: "seleccionado == 1"
            }
          ],
          staticClass: "card",
          staticStyle: { width: "85%", "overflow-y": "auto" }
        },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptionsRuta,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c("br"),
      _c(
        "v-dialog",
        {
          attrs: { width: "650px" },
          model: {
            value: _vm.categoriaDialog,
            callback: function($$v) {
              _vm.categoriaDialog = $$v
            },
            expression: "categoriaDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "card", staticStyle: { width: "100%" } },
            [
              _c("v-text-field", {
                attrs: { label: "Categorías", disabled: _vm.catShow },
                model: {
                  value: _vm.categoriaSeleccionada,
                  callback: function($$v) {
                    _vm.categoriaSeleccionada = $$v
                  },
                  expression: "categoriaSeleccionada"
                }
              }),
              _c("v-autocomplete", {
                attrs: {
                  label: "Tipos de Vehículos",
                  items: _vm.tipoVehiculos,
                  multiple: "",
                  chips: "",
                  "deletable-chips": "",
                  dense: "",
                  disabled: _vm.catShow
                },
                model: {
                  value: _vm.vehiculosSeleccionados,
                  callback: function($$v) {
                    _vm.vehiculosSeleccionados = $$v
                  },
                  expression: "vehiculosSeleccionados"
                }
              }),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.catShow,
                      expression: "!catShow"
                    }
                  ],
                  staticClass: "btn-grabar",
                  attrs: { color: "Green" },
                  on: {
                    click: function($event) {
                      _vm.editarCategoria()
                      _vm.categoriaDialog = false
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "650px" },
          model: {
            value: _vm.addCategoria,
            callback: function($$v) {
              _vm.addCategoria = $$v
            },
            expression: "addCategoria"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "card", staticStyle: { width: "100%" } },
            [
              _c("v-text-field", {
                attrs: { label: "Categorías", disabled: _vm.catShow },
                model: {
                  value: _vm.newCategoria,
                  callback: function($$v) {
                    _vm.newCategoria = $$v
                  },
                  expression: "newCategoria"
                }
              }),
              _c("v-autocomplete", {
                attrs: {
                  label: "Tipos de Vehículos",
                  items: _vm.tipoVehiculos,
                  multiple: "",
                  chips: "",
                  "deletable-chips": "",
                  dense: "",
                  disabled: _vm.catShow
                },
                model: {
                  value: _vm.newVehiculos,
                  callback: function($$v) {
                    _vm.newVehiculos = $$v
                  },
                  expression: "newVehiculos"
                }
              }),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.catShow,
                      expression: "!catShow"
                    }
                  ],
                  staticClass: "btn-grabar",
                  attrs: { color: "Green" },
                  on: {
                    click: function($event) {
                      _vm.agregarCategoria()
                      _vm.addCategoria = false
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "650px" },
          model: {
            value: _vm.tarifaDialog,
            callback: function($$v) {
              _vm.tarifaDialog = $$v
            },
            expression: "tarifaDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "card", staticStyle: { width: "100%" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Nombre",
                  items: _vm.tipoTarifas,
                  disabled: _vm.catShow
                },
                model: {
                  value: _vm.tipoTarifa,
                  callback: function($$v) {
                    _vm.tipoTarifa = $$v
                  },
                  expression: "tipoTarifa"
                }
              }),
              _c("v-text-field", {
                attrs: { label: "Descripción", disabled: _vm.catShow },
                model: {
                  value: _vm.descTarifa,
                  callback: function($$v) {
                    _vm.descTarifa = $$v
                  },
                  expression: "descTarifa"
                }
              }),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.catShow,
                      expression: "!catShow"
                    }
                  ],
                  staticClass: "btn-grabar",
                  attrs: { color: "Green" },
                  on: {
                    click: function($event) {
                      _vm.editarTarifa()
                      _vm.tarifaDialog = false
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "650px" },
          model: {
            value: _vm.addRuta,
            callback: function($$v) {
              _vm.addRuta = $$v
            },
            expression: "addRuta"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "card", staticStyle: { width: "100%" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Nombre",
                  items: _vm.tipoTarifas,
                  disabled: _vm.catShow
                },
                model: {
                  value: _vm.newtipoTarifa,
                  callback: function($$v) {
                    _vm.newtipoTarifa = $$v
                  },
                  expression: "newtipoTarifa"
                }
              }),
              _c("v-text-field", {
                attrs: { label: "Descripción", disabled: _vm.catShow },
                model: {
                  value: _vm.newdescTarifa,
                  callback: function($$v) {
                    _vm.newdescTarifa = $$v
                  },
                  expression: "newdescTarifa"
                }
              }),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.catShow,
                      expression: "!catShow"
                    }
                  ],
                  staticClass: "btn-grabar",
                  attrs: { color: "Green" },
                  on: {
                    click: function($event) {
                      _vm.agregarRuta()
                      _vm.addRuta = false
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [
                  _vm._v(
                    "Vehículos Seleccionados " + _vm._s(_vm.infoTypeReport)
                  )
                ]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card",
            { attrs: { "max-height": "300", id: "bodyDialogInfo" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "20px", "margin-top": "0px" } },
                _vm._l(_vm.infoItems, function(item) {
                  return _c(
                    "div",
                    { key: item.index, staticClass: "itemInfoDiv" },
                    [
                      _c("li", [
                        _vm._v(
                          "\n            " + _vm._s(item.value) + "\n          "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }